import {
  defineComponent,
  ref,
  provide,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
} from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import HeaderVR from '@/components/layout/header_vr.vue';
import Footer from '@/components/layout/footer.vue';
import SideComponent from '@/components/common/SideComponent.vue';
import Loading from '@/components/common/Loading.vue';
import bus from 'vue3-eventbus';
import { getShanhaiQingdaoDetail } from '@/api/common';
import { mapShanhaiQingdaoDetail } from '@/utils/newIndexMappers';
import { wexinShare, getWechatShareImgUrl } from '@/utils/wxshare.js';
import { getRouteId } from '@/utils/routeParams';

export default defineComponent({
  components: {
    PageLoading,
    HeaderVR,
    Footer,
    SideComponent,
    Loading,
  },
  setup() {
    provide('logoColor', 'black');
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const store = useStore();
    const id = getRouteId(route);

    const data = reactive({
      isLoading: true,
      isListLoading: true,
      taleDetail: {},
    });

    const showMenu = ref(proxy.$menus);
    provide('showMenu', showMenu);

    const viewBox = ref(null);
    const content = ref(null);

    const scroll = (val) => {
      if (!viewBox.value) return;
      viewBox.value.scrollIntoView({
        behavior: 'smooth',
        block: val === 'top' ? 'start' : 'end',
        inline: 'center',
      });
    };

    const wxshare = (shareData) => {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      let url = `${protocol}//${hostname}`;
      if (hostname.indexOf('www') === -1) {
        url = `${protocol}//www.${hostname}`;
      }
      url += route.fullPath;
      store.dispatch('common/Jssdk', { url }).then((res) => {
        wexinShare(res, {
          title: (shareData.title || '').replace(/<br>/gi, ' '),
          desc: '',
          link: url,
          imgUrl: shareData.thumb || getWechatShareImgUrl(store.state.common.siteInfo),
        });
      });
    };

    const loadDetail = async () => {
      data.isLoading = true;
      data.isListLoading = true;
      if (!id) {
        data.taleDetail = {};
        data.isListLoading = false;
        data.isLoading = false;
        bus.emit('showFooter', true);
        return;
      }
      try {
        const res = await getShanhaiQingdaoDetail({ id });
        const mapped = mapShanhaiQingdaoDetail(res);
        if (mapped) {
          data.taleDetail = mapped;
          wxshare(data.taleDetail);
        } else {
          data.taleDetail = {};
        }
      } catch {
        data.taleDetail = {};
      } finally {
        data.isListLoading = false;
        data.isLoading = false;
        bus.emit('showFooter', true);
      }
    };

    onMounted(() => {
      loadDetail();
    });

    return {
      ...toRefs(data),
      viewBox,
      content,
      scroll,
    };
  },
});
